import { Action } from 'redux';

import { IAccelerationTaskInfo } from '../../../../ts/models/IAccelerationTaskInfo';
import { AdminAllowAcceleration, AdminDisallowAcceleration, ChangeDataAccelerationTaskSchedule, DeleteDataAccelerationTask, RunDataAccelerationTaskRunNow } from '../../AppActionTypes';

export interface DataAccelerationTaskMenuAction extends Action {
  tasks: IAccelerationTaskInfo[];
}

export function dataAccelerationTaskRunNow(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: RunDataAccelerationTaskRunNow,
    tasks
  };
}

export function deleteDataAccelerationTask(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: DeleteDataAccelerationTask,
    tasks
  };
}

export function changeDataAccelerationTaskSchedule(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: ChangeDataAccelerationTaskSchedule,
    tasks
  };
}

export function adminAllowAcceleration(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: AdminAllowAcceleration,
    tasks
  };
}

export function adminDisallowAcceleration(tasks: IAccelerationTaskInfo[]): DataAccelerationTaskMenuAction {
  return {
    type: AdminDisallowAcceleration,
    tasks
  };
}

export enum DataAccelerationType {
  adminAllowAcceleration = 'AdminAllowAcceleration',
  adminDisallowAcceleration = 'AdminDisallowAcceleration'
}
